import type { party_enum } from '@vrplatform/graphql';
import { useMemo } from 'react';
import {
  STORYBOOK_ACCOUNTS_QUERY_KEY,
  useAccountsQuery,
} from './useAccountsQuery';
import {
  type TransactionLineAccountType,
  type TransactionLineAccountClassificationOrder,
  getTransactionLineAccountOptions,
} from './useTransactionLineAccountOptionsQuery.utils';

export const STORYBOOK_TRANSACTION_LINE_ACCOUNT_OPTIONS_QUERY_KEY =
  STORYBOOK_ACCOUNTS_QUERY_KEY;

export {
  DEPOSIT_TRANSACTION_LINE_ACCOUNT_CLASSIFICATION_ORDER,
  EXPENSE_TRANSACTION_LINE_ACCOUNT_CLASSIFICATION_ORDER,
  getTransactionLineAccountDisabledMessage,
  getTransactionLineAccountOptions,
  isTransactionLinePropertyOptionalForAccount,
} from './useTransactionLineAccountOptionsQuery.utils';

export function useTransactionLineAccountOptionsQuery(args: {
  party: party_enum | null | undefined;
  classificationOrder: TransactionLineAccountClassificationOrder;
  transactionType: TransactionLineAccountType;
  allowOwnerExpensePayoutDistribution?: boolean;
  skip?: boolean;
}) {
  const queryData = useAccountsQuery({
    skip: args.skip,
    storybookQueryKey: STORYBOOK_TRANSACTION_LINE_ACCOUNT_OPTIONS_QUERY_KEY,
  });

  const data = useMemo(
    () =>
      queryData.data
        ? getTransactionLineAccountOptions(queryData.data, {
            party: args.party,
            classificationOrder: args.classificationOrder,
            transactionType: args.transactionType,
            allowOwnerExpensePayoutDistribution:
              args.allowOwnerExpensePayoutDistribution,
          })
        : undefined,
    [
      args.allowOwnerExpensePayoutDistribution,
      args.classificationOrder,
      args.party,
      args.transactionType,
      queryData.data,
    ]
  );

  return {
    ...queryData,
    data,
  };
}
